import { casePlaceholderPrefix } from "@/Case/store/casePlaceholderPrefix";

export const getCasePlaceholderId = () => `${casePlaceholderPrefix}${Date.now()}`;
